/**
 * Wrapper for a section of a dashboard (chart, table, list).
 * Provides consistent header + container styling.
 */

import { FunctionComponent, ReactNode } from "react";

interface Props {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
}

const DashboardSection: FunctionComponent<Props> = ({
  title,
  subtitle,
  actions,
  children,
  className,
}) => (
  <section className={`bg-white rounded-md shadow-sm p-4 ${className || ""}`}>
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2 mb-3">
      <div>
        <h2 className="text-sm font-semibold text-gray-900">{title}</h2>
        {subtitle && (
          <p className="text-xs text-gray-500 mt-0.5">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
    <div>{children}</div>
  </section>
);

export default DashboardSection;
